import { t } from "i18next";

import { api } from "@/app/app.api";
import { RequestMethod } from "@/shared/utils/RequestMethod";

export const StateHealthApi = api
  .enhanceEndpoints({ addTagTypes: ["anthropometric"] })
  .injectEndpoints({
    overrideExisting: false,
    endpoints: (builder) => ({
      StateHealth: builder.query({
        query: ({ id }: any) => ({
          url: `users/${id}/advance-data`,
          method: RequestMethod.GET,
        }),
        transformResponse: (response: any) => response,
      }),
      postHealth: builder.mutation({
        query: ({ body }) => ({
          url: `user/update-advance-data-form`,
          method: RequestMethod.POST,
          body: body,
        }),
      }),
    }),
  });

export const { useStateHealthQuery, usePostHealthMutation } =
  StateHealthApi;
